import React from "react"

import { StudioManager } from "../../studio-manager";
import { Episode } from "../tile/episode";

export class SearchResults extends React.Component {
  constructor () {
    super();
    this.state = {
      episodes: [],
      amount: 8,
      hasMore: false
    }
  }

  componentDidMount () {
    this.update();
    StudioManager.instance.on('search-end', this.update);
    StudioManager.instance.on('search-start', () => { this.setState({ amount: 8 }) });
  }

  update = () => {
    console.log(StudioManager.instance.searchResults);
    var episodes = StudioManager.instance.searchResults.slice(0, this.state.amount);
    var hasMore = this.state.amount < StudioManager.instance.searchResults.length;
    this.setState({ episodes, hasMore });
  }

  more = () => {
    var amount = this.state.amount + 8;
    var hasMore = amount < StudioManager.instance.searchResults.length;
    this.setState({ amount, hasMore }, this.update);
  }

  render () {
    return (
      <div className="episodes search-results">
        <div className="episodes__title">Search Result</div>
        <div className="episodes__list">
          { this.state.episodes.map(episode => <Episode key={episode.url} episode={episode} />) }
        </div>
        { this.state.hasMore && <div className="episodes__more" onClick={this.more}>LOAD MORE</div> }
      </div>
    );
  }
}
